import type { ReactNode } from 'react';

interface ScreenProps {
  /** Verwijst naar de artboardcode (README §Schermen). */
  name: string;
  children: ReactNode;
  foot?: ReactNode;
  footDivided?: boolean;
  centered?: boolean;
}

/**
 * Elk scherm is één kolom: alles boven de voet scrollt, de voet met de primaire actie
 * blijft staan. Dat is wat "primaire knop zichtbaar op 360 × 640" afdwingt.
 */
export function Screen({ name, children, foot, footDivided = false, centered = false }: ScreenProps) {
  return (
    <div className="screen" data-screen={name}>
      <div className={`screen__body${centered ? ' screen__body--center' : ''}`}>{children}</div>
      {foot ? (
        <div className={`screen__foot${footDivided ? ' screen__foot--divided' : ''}`}>{foot}</div>
      ) : null}
    </div>
  );
}

interface LiveRegionProps {
  children: ReactNode;
  assertive?: boolean;
}

/** Live-regio voor de teller en de scanuitkomst (README §Toegankelijkheid). */
export function LiveRegion({ children, assertive = false }: LiveRegionProps) {
  return (
    <span className="visually-hidden" role="status" aria-live={assertive ? 'assertive' : 'polite'}>
      {children}
    </span>
  );
}
